import { extendObservable } from 'mobx'
import type { TodistuksetUser } from 'todistukset-common/src/vtj/types/user'
import { useAetTodistuspyyntoId } from 'todistukset-ui/src/vtj/components/order-wizard-aet-signer/aetSignerSteps'
import { getAetOrdererFromUser } from 'todistukset-ui/src/vtj/stores/aet-orderer-form.store'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import { createAetTodistuspyyntoStore } from 'todistukset-ui/src/vtj/stores/aet-todistuspyynto.store'
import { AetSignerUiForm } from 'todistukset-common/src/vtj/types/form-types.type'
import {
  editIlmoitettuArvo,
  Puhelinnumero,
  Sahkopostiosoite,
  SukulaisuussuhdeVakuutettu,
} from 'todistukset-common/src/vtj/types/editable-field.type'
import { TodistusAsiointikieli } from 'todistukset-common/src/vtj/types/todistus-person.type'

export const createAetSignerFormStore = (
  user: TodistuksetUser | undefined,
  asiointikieli: TodistusAsiointikieli
): AetSignerUiForm => {
  const aetTodistuspyyntoStore = createAetTodistuspyyntoStore()
  return extendObservable(aetTodistuspyyntoStore, {
    orderer: getAetOrdererFromUser(user, asiointikieli),
    sukulaisuussuhdeVakuutettu: editIlmoitettuArvo<SukulaisuussuhdeVakuutettu>(
      null,
      false
    ),
    contactInfo: {
      email: editIlmoitettuArvo<Sahkopostiosoite>(null, ''),
      phoneNumber: editIlmoitettuArvo<Puhelinnumero>(null, ''),
    },
  })
}

export const useAetSignerForm = (): AetSignerUiForm => {
  const aetTodistuspyyntoId = useAetTodistuspyyntoId()
  const { aetSignerFormFn } = useStore()
  return aetSignerFormFn(aetTodistuspyyntoId)
}
